import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import ROUTES from '~/shared/constants/routes.const'
import { ButtonPrimary } from '~/components/Buttons'
import { MultiplicationMasterAPIStat } from '~/redux/apis/user-stats-api'
import SVGImage from '~/components/Image/SVGImage'

import ActivitySummary from './MultgameActivitySummary'
import MultGameSurvivalSprint from './MultGameSurvivalSprint'
import MultGameTableStats from './MultGameTableStats'

export default function MultGameDetails({ product }: { product: MultiplicationMasterAPIStat }): React.ReactElement {
  const { t } = useTranslation('statistics')
  const router = useRouter()
  const isFamilyView = router.asPath.includes(ROUTES.FAMILY_ADMIN_PANEL)

  const { totalActivitiesSolvedCount, accuracy } = product.summary
  const { sprint, survival, tablesMaster } = product.details
  const btnText = t('play')

  return (
    <div>
      <div className="flex space-x-4 my-4 pt-2">
        <ActivitySummary totalActivitiesSolvedCount={totalActivitiesSolvedCount} />
        <div className="w-full grow font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
          <p className="text-center">
            <span className="text-purple">{t('multGame.accuracy')}</span>
          </p>
          <SVGImage
            alt={t('alt_texts.activity_accuracy')}
            imageClassName="mx-auto"
            srcKey="scoreboard/multgame_accuracy.svg"
            width={66}
          />
          <p className="text-center">{accuracy.toFixed(0)}%</p>
        </div>
      </div>

      <div className="my-4 w-full h-0.5 bg-purple-light" />
      <div className="relative">
        <MultGameSurvivalSprint
          accuracy={survival.accuracy}
          bestStreak={survival.bestStreak}
          imgSrcKey="scoreboard/survival.svg"
          score={survival.score}
          title={t('multGame.survival')}
        />

        <MultGameSurvivalSprint
          accuracy={sprint.accuracy}
          bestStreak={sprint.bestStreak}
          imgSrcKey="scoreboard/sprint.svg"
          score={sprint.score}
          title={t('multGame.sprint')}
        />

        <MultGameTableStats tables={tablesMaster.tables} />

        {!isFamilyView && (
          <ButtonPrimary className="ml-auto mt-4 py-0.5 px-7" href={ROUTES.MULT_GAME} noPadding size="medium">
            {btnText}
          </ButtonPrimary>
        )}
      </div>
    </div>
  )
}
